jQuery(document).ready(function(){
  $(document).click(function(event) { 
    var $target = $(event.target);
    if(!$target.closest('.header-wrapper').length) {
      $('.header-wrapper').removeAttr('active');
    }
  });

  $('sticky-header.header-wrapper').on('mouseleave',function(event){
    $('.header__inline-menu header-menu details').removeAttr('open');
    $(this).removeAttr('active')
  })

  $('header-menu>details summary.list-menu__item').hover(function(){
    if(!$(this).parents('details').attr('open')){
      $('.header__inline-menu header-menu details').removeAttr('open');
      $(this).parents('details').prop('open',true)
      $(this).parents('.header-wrapper').attr('active',true)
    }
  })  

  if($(window).width() <= 989.89){
      var menuFooter = $('.footer .footer__content-middle .grid');
      var menuHeight = menuFooter.height();
      menuFooter.height(menuHeight/2 + 50);
    }else{
      $('.footer .footer__content-middle .grid').removeAttr('style');
    }
  $(window).resize(function(){
    if($(window).width() <= 989.89){
      $('.footer .footer__content-middle .grid').removeAttr('style');
      var menuFooter = $('.footer .footer__content-middle .grid');
      var menuHeight = menuFooter.height();
      menuFooter.height(menuHeight/2 + 50);
    }else{
      $('.footer .footer__content-middle .grid').removeAttr('style');
    }
  })

  function paddingTopSearch(){
    var headerHeight = $('.header-wrapper').height();
    var announcementHeight = $('.announcement-bar-slider').height(); 
    var paddingTop = headerHeight + announcementHeight;
    $('.header__search details .search-modal').css('top',paddingTop)
    $('.header__icon--search').click(function(){
       $('.section-header').toggleClass('open-searchform');
      
    })
    $('.header__search details .modal__close-button.link').click(function(){
       $('.section-header').removeClass('open-searchform');
    })
  }
  paddingTopSearch();

  $('.announcement-bar-section .icon-right .modal__toggle-open.icon-search').click(function(){
    if($(this).parents('body').find('.header .header__icons .header__search details').attr('open')){
      $(this).parents('body').find('.header .header__icons').removeClass('open');
      $(this).parents('body').find('.header .header__icons .header__search details').removeAttr('open');                                                                               
    }else{
      $(this).parents('body').find('.header .header__icons').addClass('open');
      $(this).parents('body').find('.header .header__icons .header__search details').attr('open',true);
    }
  })

  $('.header__search details .modal__close-button .icon').click(function(){
    $(this).parents('body').find('.header .header__icons').removeClass('open');
  })

   if ($(".template-testimonials").length) {
       $(".template-testimonials .video-section").attr('play', false);
       $(window).scroll(function() {
           var heightVideo = $(".template-testimonials .video-section").height();
           var play = $(".template-testimonials .video-section").attr('play');
           if (($(window).scrollTop() + heightVideo) > $(".template-testimonials .video-section").offset().top) {
               if (play == "false") {
                   $(".template-testimonials .video-section .video-section__poster").click();
                   $(".template-testimonials .video-section").attr('play', true);
                   return
               }
           }
       });
   }
})